import style from './wallex-block.module.scss'
import WallexText from './wallex-text/wallex-text';
import WallexTitle from '@components/projects/wallex/wallex-block/wallex-title/wallex-title';


const WallexBlock = (props: any) => {
    let { state } = props;
    return (
        <>
            <div className={style.wallex__block}>
                <div className={style.wallex__block__title}>
                    <WallexTitle size={'md'} state={state.title} />
                </div>
                <div className={style.wallex__block__text}>
                    {
                        state.text.map((item: any) => {
                            return (
                                <WallexText key={item.id} state={item.text} />
                            )
                        })
                    }
                </div>
            </div>
        </>
    )


}

export default WallexBlock;

